import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoogoatwodayspackages() {



const cardData =
{
  keyword: 'Pune to Goa 2 Days Package',

  heading: 'Lotus Cab: Pune to Goa 2 Days Package ',

headingDescription:
  "Lotus Cabs offers a convenient and affordable Pune to Goa 2 Days Package for travelers looking for a quick and memorable Goa getaway. Our two-day tour packages are ideal for families, couples, friends, and corporate groups who want comfortable travel, flexible sightseeing, and hassle-free transportation. Enjoy your journey with our premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus, driven by professional and experienced chauffeurs. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, clean and well-maintained vehicles, and safe highway travel, Lotus Cabs ensures a smooth, enjoyable, and comfortable Pune to Goa 2 Days Package experience.",

  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
   
    {
        title: "Kakolem Beach",
        description:
            "Kakolem Beach, also known as Tiger Beach, is a secluded coastal paradise surrounded by cliffs and greenery. Its untouched beauty, peaceful atmosphere, and scenic views make it one of Goa's best offbeat beach destinations."
    },
    {
        title: "Betul Beach",
        description:
            "Betul Beach is a quiet fishing village beach in South Goa known for its serene coastline, traditional seafood, and beautiful sunset views. The peaceful surroundings make it perfect for travelers looking to experience authentic Goan culture."
    },
     {
        title: "Grand Island",
        description:
            "Grand Island is one of Goa's most popular adventure destinations, famous for snorkeling, scuba diving, fishing, and exploring vibrant marine life. Surrounded by crystal-clear waters of the Arabian Sea, the island offers an exciting experience for adventure seekers and nature lovers."
    },
    {
        title: "Cotigao Wildlife Sanctuary",
        description:
            "Cotigao Wildlife Sanctuary is one of Goa's oldest wildlife reserves, known for dense forests, diverse wildlife, and beautiful natural landscapes. Visitors can explore walking trails, spot animals and birds, and enjoy the peaceful environment away from crowded tourist areas."
    },
    {
        title: "Netravali Wildlife Sanctuary",
        description:
            "Netravali Wildlife Sanctuary is a hidden gem in South Goa, famous for lush green forests, waterfalls, trekking routes, and rich biodiversity. The sanctuary offers a refreshing experience for travelers interested in nature, photography, and wildlife exploration."
    },
    {
        title: "Cabo de Rama Fort",
        description:
            "Cabo de Rama Fort is a historic fort located on a cliff overlooking the Arabian Sea. Famous for its spectacular ocean views, ancient architecture, and peaceful surroundings, it is an excellent destination for history lovers and sunset photography."
    },
    {
        title: "Salaulim Dam",
        description:
            "Salaulim Dam is a scenic attraction surrounded by lush greenery and natural landscapes. The unique spillway design, peaceful reservoir, and beautiful gardens make it a relaxing destination for families and nature enthusiasts."
    },
    {
        title: "Hollant Beach",
        description:
            "Hollant Beach is a calm and less crowded beach near Vasco da Gama, known for its shallow waters, peaceful environment, and stunning sunrise views. It is an ideal spot for swimming, photography, and enjoying a relaxing coastal experience."
    },
    {
        title: "Kesarval Spring",
        description:
            "Kesarval Spring is a natural spring near Cortalim known for its scenic surroundings and traditional importance. Surrounded by greenery, the location offers visitors a peaceful escape and a chance to explore Goa's natural attractions."
    },
    {
        title: "Palácio do Deão",
        description:
            "Palácio do Deão is a historic Portuguese-style heritage mansion located in Quepem, Goa. Known for its beautiful architecture, riverside gardens, and cultural significance, the palace offers visitors a glimpse into Goa's colonial-era lifestyle and traditions."
    }
],





"services": [
  {
    "name": "Pune to Goa 2 Days Package",
    "description": "Book Pune to Goa 2 days package for a quick and refreshing getaway to Goa's beautiful beaches and popular tourist attractions. This package is ideal for families, couples, and friends looking for a short vacation with comfortable cab transportation, flexible travel schedules, and sightseeing opportunities. Enjoy a hassle-free trip with professional drivers, spacious vehicles, and customized itineraries designed for a memorable two-day holiday."
  },
  {
    "name": "Pune to Goa 2 Days Tour Package",
    "description": "Pune to Goa 2 days tour package offers a perfect weekend escape with comfortable travel arrangements and personalized sightseeing plans. Explore famous beaches, churches, forts, and local markets while traveling in well-maintained AC vehicles. The package is suitable for families and small groups looking for an enjoyable short vacation without the stress of planning transportation."
  },
  {
    "name": "Pune to Goa 2 Days Cab Package",
    "description": "Book Pune to Goa 2 days cab package and enjoy the convenience of private transportation for your short trip to Goa. Choose from sedan, Ertiga, and Innova vehicles according to your group size and luggage requirements. Flexible pickup timings and experienced drivers ensure a comfortable and relaxing travel experience."
  },
  {
    "name": "Pune to Goa Weekend Package",
    "description": "Pune to Goa weekend package is specially designed for travelers looking to spend a relaxing weekend at Goa's famous beaches and attractions. The package includes comfortable cab services, customized itineraries, and flexible travel plans, making it ideal for families, couples, and groups seeking a memorable short vacation."
  },
  {
    "name": "Pune to Goa Short Trip Package",
    "description": "Enjoy a refreshing holiday with Pune to Goa short trip package that offers convenient transportation and a well-planned itinerary for a quick getaway. Perfect for long weekends and mini vacations, this package provides comfortable travel arrangements and sufficient time to explore Goa's popular destinations."
  },
  {
    "name": "Pune to Goa Family 2 Days Package",
    "description": "Pune to Goa family 2 days package is ideal for families seeking a short yet memorable vacation. Spacious vehicles like Ertiga and Innova provide comfortable travel for all family members, while customized sightseeing plans help you enjoy the best of Goa in just two days."
  },
  {
    "name": "Pune to Goa Holiday Package 2 Days",
    "description": "Book Pune to Goa holiday package 2 days and enjoy a stress-free beach vacation with comfortable transportation and flexible itineraries. This package is perfect for couples, families, and groups wanting to experience Goa's scenic beauty, local culture, and famous attractions in a short duration."
  },
  {
    "name": "Pune to Goa Taxi Package 2 Days",
    "description": "Pune to Goa taxi package 2 days offers private cab transportation with experienced drivers and comfortable vehicles for a convenient short trip. The package includes flexible departure timings and sightseeing options, making it an excellent choice for families and tourists."
  },
  {
    "name": "Goa 2 Days Package from Pune",
    "description": "Goa 2 days package from Pune provides a complete travel solution for a quick holiday with private cab services and personalized itineraries. Enjoy a relaxing journey in AC vehicles and explore Goa's beautiful beaches, churches, and markets during your short stay."
  },
  {
    "name": "Pune to Goa Tour by Cab 2 Days",
    "description": "Book Pune to Goa tour by cab 2 days and enjoy the flexibility of private transportation with customized sightseeing and travel plans. Professional drivers, comfortable vehicles, and convenient pickup services make this package ideal for weekend vacations and family trips to Goa."
  }
],

"tableData": [
  ["Pune to Goa 2 Days Package", "Pune to Goa 2 Days Tour Package"],
  ["Pune to Goa 2 Days Cab Package", "Pune to Goa Weekend Package"],
  ["Pune to Goa Short Trip Package", "Pune to Goa Family 2 Days Package"],
  ["Pune to Goa Holiday Package 2 Days", "Pune to Goa Taxi Package 2 Days"],
  ["Goa 2 Days Package from Pune", "Pune to Goa Tour by Cab 2 Days"]
],






"whychoose": [
  {
    "WhyChooseheading": "Perfect Weekend Getaway",
    "WhyChoosedescription": "Enjoy a refreshing 2-day Goa trip from Pune with a well-planned and comfortable travel package."
  },
  {
    "WhyChooseheading": "Flexible Travel Itinerary",
    "WhyChoosedescription": "Customize your 2-day package according to your sightseeing and travel preferences."
  },
  {
    "WhyChooseheading": "Comfortable Vehicle Options",
    "WhyChoosedescription": "Choose from Sedan, Ertiga, Innova Crysta, and SUVs for a relaxing journey to Goa."
  },
  {
    "WhyChooseheading": "Budget-Friendly Package",
    "WhyChoosedescription": "Affordable package pricing designed for couples, families, and groups."
  },
  {
    "WhyChooseheading": "Doorstep Pickup Service",
    "WhyChoosedescription": "Convenient pickup from homes, hotels, airports, and railway stations in Pune."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs",
    "WhyChoosedescription": "Professional drivers ensure safe and comfortable travel throughout your Goa trip."
  },
  {
    "WhyChooseheading": "Ideal for Short Vacations",
    "WhyChoosedescription": "A perfect package for weekend holidays, quick family trips, and friends' getaways."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance",
    "WhyChoosedescription": "Dedicated support team available to assist with package details and reservations."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide a Pune to Goa 2 Days Package?',
    answer: 'Yes, Lotus Cab offers customized 2-day Goa packages from Pune for families, couples, and groups.'
  },
  {
    question: 'What is included in the Pune to Goa 2 Days Package?',
    answer: 'The package includes a comfortable cab with a professional driver and flexible travel options. The itinerary can be customized according to your requirements.'
  },
  {
    question: 'What is the distance between Pune and Goa?',
    answer: 'The distance from Pune to Goa is approximately 450 km and the journey generally takes around 8 to 10 hours.'
  },
  {
    question: 'Which vehicles are available for the 2-day package?',
    answer: 'We offer Sedan cars, Ertiga, Innova Crysta, and SUVs depending on the number of travelers and luggage requirements.'
  },
  {
    question: 'Can I customize my Goa itinerary?',
    answer: 'Yes, the package can be personalized based on your preferred destinations, travel dates, and sightseeing plans.'
  },
  {
    question: 'Do you provide pickup from Pune Airport and railway station?',
    answer: 'Yes, Lotus Cab provides pickup services from Pune Airport, railway stations, hotels, and residential locations.'
  },
  {
    question: 'Are toll and parking charges included in the package?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically included in the quotation.'
  },
  {
    question: 'Is this package suitable for families and couples?',
    answer: 'Absolutely. The 2-day Goa package is ideal for couples, families, and friends looking for a short vacation.'
  },
  {
    question: 'Can I extend the package beyond two days?',
    answer: 'Yes, we offer flexible options to extend your Goa stay and customize the package duration.'
  },
  {
    question: 'How can I book a Pune to Goa 2 Days Package with Lotus Cab?',
    answer: 'Share your travel date, pickup location, number of passengers, and preferred vehicle to receive package details and instant booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Harshal Patil',
    feedback: 'Our weekend escape to Goa was perfectly organized. The 2-day package gave us enough time to relax and explore without worrying about transportation.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Rhea Shah',
    feedback: 'We wanted a short Goa vacation from Pune, and this package turned out to be the ideal choice. The cab was comfortable, and the entire trip was managed smoothly.',
    rating: 5,
  },
];








































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa 2 Days Package",
"image": "https://lotuscab.com/assets/images/pune-to-goa-2-days-package.jpg",
"description": "Book Pune to Goa 2 Days Package with Lotus Cab for a comfortable and exciting short trip. Enjoy weekend tours, family holiday packages, and private cab tours from Pune to Goa with professional drivers and comfortable AC cabs available 24x7.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-2-days-package"
}
};






  return (
    <div>
      


<Helmet>
  <title>Pune to Goa 2 Days Package | Weekend Tour by Cab | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa 2 Days Package with Lotus Cab for affordable weekend trips and short tours. Get family cab packages, holiday taxi packages, and private Goa tour by cab with professional drivers."
/>

<meta
 name="keywords"
 content="Pune to Goa 2 Days Package, Pune to Goa 2 Days Tour Package, Pune to Goa 2 Days Cab Package, Pune to Goa Weekend Package, Pune to Goa Short Trip Package, Pune to Goa Family 2 Days Package, Pune to Goa Holiday Package 2 Days, Pune to Goa Taxi Package 2 Days, Goa 2 Days Package from Pune, Pune to Goa Tour by Cab 2 Days"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>






 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/104.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoogoatwodayspackages;